// extracted by mini-css-extract-plugin
module.exports = {"v-collapse":"v-collapse_v-collapse_1Ucad","button":"v-collapse_button_2B-2k","arrow":"v-collapse_arrow_2z4ll","expanded":"v-collapse_expanded_3y0j3"};